import InputSelectSimple from './InputSelectSimple';

export default InputSelectSimple;
